<template>

  <v-card class="vehicle-card" v-if="vehicle" @click="itemClicked">
    <v-card-title>
      <v-row class="pa-0 ma-0">
        <v-col cols="6" class="pa-0 ma-0">
          {{ vehicle.license_plate }}
        </v-col>
        <v-col cols="6" class="pa-0 ma-0 d-flex align-center justify-end">
          <v-chip small label outlined :class="vehicle.vehicle_status">
            {{ vehicle.vehicle_status }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text style="font-size:16px;">
      <div>
        {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.vehicle_model }} - {{ vehicle.color }}
      </div>
      <div class="mt-2" v-if="vehicle.nickname">
        <span>"{{ vehicle.nickname }}"</span>
      </div>
    </v-card-text>
  </v-card>

</template>

<script>
export default {
  name: 'VehicleStatusCard',

  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },

  methods: {
    itemClicked () {
      this.$emit('itemClicked', this.vehicle)
    }
  }
}
</script>

<style>
  .vehicle-card {
    height: 146px;
  }

  .vehicle-card.theme--dark.v-card {
    border: 1px solid #262626;
    border-radius: 4px;
    background-color: #161616;
  }

  .vehicle-nickname {
    font-style: italic;
  }
</style>
